import { makeStyles, withStyles, fade } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";

export const InputField = withStyles((theme) => ({
  root: {
    width: "100%",
    borderRadius: 5,
    "&:hover": {
      "& $notchedOutline": {
        borderColor: "#CCC",
      },
    },
    "&$focused": {
      "& $notchedOutline": {
        borderWidth: 1,
        borderColor: "#CCC",
        boxShadow: `${fade("#9B9B9B", 0.24)} 0 0 0 0.15rem`,
      },
    },
  },
  input: {
    fontFamily: 'Montserrat, "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif',
    height: "auto",
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    padding: "12px 16px",
    width: "100%",
    maxWidth: '60px',
    background: "#FFF",
    borderRadius: 5,
    color: "#000000",
    textAlign: "center",
    fontWeight: 600,
    // color: (props) => (props.fontColor ? props.fontColor : '#4A4A4A'),
    [theme.breakpoints.down("xs")]: {
      maxWidth: '38px',
    },
  },
  focused: {},
  notchedOutline: {
    borderRadius: 5,
    borderColor: "#CCC",
  },
  multiline: {
    padding: 0,
  },
  disabled: {},
}))(OutlinedInput);

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: 32,
    color: "#FFF",
    backgroundColor: `${fade("#263593", 0.6)}`,
    borderRadius: 75,
    [theme.breakpoints.down("xs")]: {
      borderRadius: "unset",
    },
  },
  img: {
    width: "100%",
    borderRadius: 25,
  },
  content: {
    // paddingLeft: '24px',
  },
  text: {
    fontWeight: 600,
    fontSize: "1.25rem",
    lineHeight: "2rem",
    textAlign: "center",
  },
  sectionInputCode: {
    marginTop: 32,
  },
  sectionButton: {
    marginTop: 32,
  },
  button: {
    padding: "10px 16px",
    fontFamily: 'Montserrat, "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif',
    fontSize: "1.5rem",
    fontWeight: 600,
    lineHeight: "2rem",
    borderRadius: 10,
    color: "#FFFFFF",
    backgroundColor: "#5791bf",
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "#5791bf",
    },
  },
}));

export default useStyles;
